export const TAB_COMPANIES = {
	ALL: 'all',
	ANIMATOR: 'animator',
	OPERATOR: 'operator',
	SELLER: 'seller',
	ADMIN: 'admin',
};

export const getFilteredCompanyTypes = types => {
	return types.filter(type => (
		type.identifier === 'animator' ||
		type.identifier === 'agreement-operator' ||
		type.identifier === 'sales-document-issuer'
	));
};

export const formatTypes = (options, types) => {
	if(!options || !types) return null;

	const items = options.map(option => types.includes(option.identifier) ? ` ${option.name}` : null);
	return items.filter(item => item).toString();
};